import { useLocation, useNavigate } from 'react-router-dom';
import { Globe } from 'lucide-react';
import { SettingsWorkspace } from '@reach/settings-workspace';
import { useActiveStore } from '../store';

function EmptyWorkspaceState() {
  const navigate = useNavigate();

  return (
    <div className="flex min-h-screen flex-col items-center justify-center bg-white px-6 py-24 text-center">
      <div className="mb-6 flex h-16 w-16 items-center justify-center rounded-2xl border border-zinc-100 bg-white shadow-sm">
        <Globe size={30} className="text-zinc-300" />
      </div>
      <h1 className="mb-2 text-2xl font-black tracking-tight text-zinc-950">Choose a store first</h1>
      <p className="mb-8 max-w-sm text-sm font-medium leading-6 text-zinc-500">
        The workspace loads the selected store’s appearance, assistant, analytics, and subscription tabs.
      </p>
      <button
        onClick={() => navigate('/stores')}
        className="theme-btn-primary rounded-xl px-6 py-3 text-sm font-bold shadow-sm transition-all active:scale-[0.98]"
      >
        View stores
      </button>
    </div>
  );
}

const ROUTE_TAB_MAP: Record<string, string> = {
  '/appearance': 'visual-editor',
  '/chatbot': 'assistant',
  '/analytics': 'analytics',
  '/subscription': 'plans',
  '/workspace': 'visual-editor',
};

export function MerchantWorkspace() {
  const location = useLocation();
  const activeStore = useActiveStore();
  const initialTabId = ROUTE_TAB_MAP[location.pathname] || 'visual-editor';

  if (!activeStore) return <EmptyWorkspaceState />;

  return (
    <div className="min-h-screen bg-white">
      <SettingsWorkspace
        key={activeStore.id}
        shopDomain={activeStore.externalDomain}
        initialTabId={initialTabId}
        layoutVariant="headless"
        showOnboarding
      />
    </div>
  );
}
